import React, { useState, useRef, useEffect } from "react";

export default function CustomSelect({value, onChange, options, placeholder, lang}){
  /* Prefer explicit lang prop; otherwise detect from document.documentElement.lang. */
  const effLang=lang||(typeof document!=="undefined"?(document.documentElement.lang||"en"):"en");
  const isRTL=effLang==="ar";
  const ph=placeholder||(isRTL?"اختر…":"Select…");
  const searchPh=isRTL?"بحث…":"Search…";
  const noResultsLabel=isRTL?"لا نتائج":"No results";
  const [open,setOpen]=useState(false);
  const [search,setSearch]=useState("");
  const ref=useRef(null);
  const selected=options.find(o=>o.value===value);
  const q=search.toLowerCase();
  const filtered=q?options.filter(o=>o.label.toLowerCase().includes(q)):options;
  const showSearch=options.length>5;
  useEffect(()=>{
    if(!open)return;
    const h=e=>{if(ref.current&&!ref.current.contains(e.target)){setOpen(false);setSearch("");}};
    document.addEventListener("mousedown",h);
    return()=>document.removeEventListener("mousedown",h);
  },[open]);
  return(
    <div ref={ref} style={{position:"relative",width:"100%"}}>
      <button type="button" onClick={()=>setOpen(o=>!o)}
        style={{width:"100%",display:"flex",alignItems:"center",justifyContent:"space-between",
          background:"var(--white)",border:"1.5px solid var(--g200)",borderRadius:"var(--r)",
          color:selected?"var(--ink)":"var(--g300)",fontSize:13.5,padding:"8px 11px",cursor:"pointer",
          fontFamily:"inherit",outline:"none",textAlign:"left",gap:8,transition:"border-color .12s,box-shadow .12s"}}>
        <span style={{flex:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",display:"flex",alignItems:"center",gap:6}}>
          <span style={{overflow:"hidden",textOverflow:"ellipsis"}}>{selected?selected.label:ph}</span>
          {selected?.badge&&<span style={{fontSize:9,fontWeight:600,padding:"1px 6px",borderRadius:10,background:"var(--g100)",color:"var(--g500)",textTransform:"uppercase",letterSpacing:".05em",flexShrink:0}}>{selected.badge}</span>}
        </span>
        <svg width="10" height="6" viewBox="0 0 10 6" style={{flexShrink:0,opacity:.4,transform:open?"rotate(180deg)":"none",transition:"transform .15s"}}><path d="M0 0l5 6 5-6z" fill="currentColor"/></svg>
      </button>
      {open&&(
        <div style={{position:"absolute",top:"calc(100% + 4px)",left:0,right:0,zIndex:300,
          background:"var(--white)",border:"1.5px solid var(--g200)",borderRadius:"var(--r2)",
          boxShadow:"0 8px 24px rgba(26,23,20,.12)"}}>
          {showSearch&&(
            <div style={{padding:"8px 10px",borderBottom:"1px solid var(--g100)"}}>
              <input autoFocus value={search} onChange={e=>setSearch(e.target.value)}
                placeholder={searchPh}
                style={{width:"100%",background:"var(--g50)",border:"1px solid var(--g200)",borderRadius:6,
                  color:"var(--ink)",fontSize:13,padding:"6px 10px",outline:"none",fontFamily:"inherit"}}/>
            </div>
          )}
          <div style={{maxHeight:220,overflowY:"auto"}}>
            {filtered.length===0
              ?<div style={{padding:"10px 12px",fontSize:12,color:"var(--g400)",textAlign:"center"}}>{noResultsLabel}</div>
              :filtered.map(o=>(
                <div key={o.value} onClick={()=>{onChange(o.value);setOpen(false);setSearch("");}}
                  style={{padding:"9px 12px",cursor:"pointer",fontSize:13.5,color:"var(--ink)",
                    background:value===o.value?"var(--g100)":"transparent",
                    display:"flex",alignItems:"center",gap:8}}
                  onMouseEnter={e=>e.currentTarget.style.background=value===o.value?"var(--g100)":"var(--g50)"}
                  onMouseLeave={e=>e.currentTarget.style.background=value===o.value?"var(--g100)":"transparent"}>
                  <span style={{flex:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{o.label}</span>
                  {o.badge&&<span style={{fontSize:9,fontWeight:600,padding:"1px 6px",borderRadius:10,background:"var(--g100)",color:"var(--g500)",textTransform:"uppercase",letterSpacing:".05em",flexShrink:0}}>{o.badge}</span>}
                </div>
              ))
            }
          </div>
        </div>
      )}
    </div>
  );
}
